import {MIN_ROUND_OFF_VALUE} from '../constants';
import {NumberFormat} from '../number';
import {roundOff as roundFunction} from '../number/utils';
import {convertToDigit} from '../utils';

import type {Locale} from '../number';

type FormatOptions = {
    roundOff?: boolean,
    hideTrailingZeros?: boolean,
};
type Options = {
    digitsCount?: number,
};

const getRoundOffDecimal = (value: number) =>
    (value < MIN_ROUND_OFF_VALUE && value > 1 ? 0 : 2);

export class HumanReadableFormat {
    formatOptions: Options | null | undefined;

    constructor(formatOptions?: Options) {
        this.formatOptions = formatOptions;
    }

    format(
        value: number,
        locale: Locale,
        {hideTrailingZeros = false, roundOff = false}: FormatOptions,
    ) {
        const result = convertToDigit({
            value: roundOff ? roundFunction(value) : value,
        });
        const moduloResult = Math.abs(result.value);
        let computedModulo;

        if (moduloResult < 10) {
            computedModulo = 2;
        } else {
            computedModulo = moduloResult < 100 ? 1 : 0;
        }

        const decimals =
            (this.formatOptions && this.formatOptions.digitsCount) ||
            (roundOff ? getRoundOffDecimal(Math.abs(value)) : computedModulo);
        return (
            new NumberFormat(decimals, true).formatNumber(
                result.value,
                locale,
                {
                    hideTrailingZeros,
                },
            ) + result.digit
        );
    }
}
